import { Col, Collapse, Row, Typography } from "antd";

const ReportItem = ({ values }: IReportItem) => {
  const getColor = (value: number): string => {
    return value > 50 ? "#FFD000" : value > 80 ? "#FF1E00" : "#00FF51";
  };
  return (
    <Row
      style={{ background: "#0051ff", textAlign: "center" }}
      gutter={[24, 24]}
    >
      <Col
        span={1}
        style={{ background: getColor(values[2]), padding: "10px" }}
      ></Col>
      <Col span={8} style={{ background: "#EFEFEF", padding: "10px" }}>
        {values[0]}
      </Col>
      <Col span={8} style={{ background: "#F8F5F5", padding: "10px" }}>
        {values[1]}
      </Col>
      <Col span={7} style={{ background: "#EFEFEF", padding: "10px" }}>
        {values[2]}%
      </Col>
    </Row>
  );
};

export interface IResultReport3D {
  name: string;
  lesion: number;
  score: [string, number][];
}

interface Props {
  values: IResultReport3D[];
}

const AbusAiReport = (props: Props) => {
  return (
    <>
      {props.values?.map((item, index) => (
        <Collapse
          key={`collapse-${index}`}
          collapsible="header"
          expandIconPosition="right"
          style={{ marginBottom: 10 }}
        >
          <Collapse.Panel
            header={<div style={{ width: "100%" }}>{item.name}</div>}
            key={`panel-${index}`}
          >
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Typography.Text>จำนวน Lesion : {item.lesion}</Typography.Text>
                <div style={{ overflow: "hidden", borderRadius: 6 }}>
                  <Row
                    style={{
                      background: "#0051ff",
                      color: "#fff",
                      textAlign: "center",
                    }}
                    gutter={[24, 24]}
                  >
                    <Col span={1} style={{ padding: "10px" }}></Col>
                    <Col span={8} style={{ padding: "10px" }}>
                      Lestion
                    </Col>
                    <Col span={8} style={{ padding: "10px" }}>
                      Average classification score
                    </Col>
                    <Col span={7} style={{ padding: "10px" }}>
                      Malignant
                    </Col>
                  </Row>
                  {item?.score?.map((itemScore, index) => (
                    <ReportItem
                      key={`report-item-${index}`}
                      values={[
                        itemScore[0],
                        itemScore[1],
                        Math.round(itemScore[1] * 100),
                      ]}
                    />
                  ))}
                </div>
              </Col>
            </Row>
          </Collapse.Panel>
        </Collapse>
      ))}
    </>
  );
};
export default AbusAiReport;

interface IReportItem {
  values: any[];
}
